import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0589c08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = { class: "dialog-footer" }

import { ref, watch } from 'vue'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import { CODE_ENUM } from '@/common'
import { deviceThingTemplateAdd, deviceThingTemplateUpdate } from '@/api'
import { isEmpty } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'template-form',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: __emit }) {

const $emit = __emit
const props = __props

const formData = ref({
  modelName: '',
  remarks: '',
})
const rules: any = {
  modelName: [{ required: true, message: '请输入' }],
}

watch(
  () => props.visible,
  () => {
    if (props.visible && !isEmpty(props.data)) {
      const { modelName, remarks } = props.data
      formData.value = {
        modelName,
        remarks,
      }
    }
  }
)

const cancel = () => {
  $emit('update:visible', false)
  formRef.value.resetFields()
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()

const handleAddDevice = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      loading.value = true
      const fn = props.data.id
        ? deviceThingTemplateUpdate
        : deviceThingTemplateAdd
      const res: any = await fn({
        ...formData.value,
        id: props.data.id,
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage({
          message: props.data.id ? '修改产品成功' : '新建产品成功',
          type: 'success',
        })
        cancel()
        $emit('success')
      }
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: props.data.id ? '编辑产品模板' : '添加产品模板',
    width: "480px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, { onClick: cancel }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: handleAddDevice
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          model: formData.value,
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          "label-position": "left",
          "label-width": "80"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "modelName",
              label: "模板名称"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.modelName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.modelName) = $event)),
                  maxlength: "20",
                  placeholder: "请输入模板品名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "remarks",
              label: "备注"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.remarks,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.remarks) = $event)),
                  maxlength: "500",
                  placeholder: "请输入你的备注",
                  rows: 4,
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})